import React, { useState, useRef, useEffect } from "react";

const songs = [
  {
    id: 7,
    title: "God's Plan",
    artist: "Drake",
    genre: "Hip-Hop",
    audioSrc: "/audio/plan.mp3",
    albumCover: "/images/plan.jpg",
  },
  {
    id: 4,
    title: "What a Wonderful World",
    artist: "Louis Armstrong",
    genre: "Jazz",
    audioSrc: "/audio/world.mp3",
    albumCover: "/images/world.jpg",
  },
  {
    id: 10,
    title: "Bad Boys",
    artist: "Inner Circle",
    genre: "Reggae",
    audioSrc: "/audio/boys.mp3",
    albumCover: "/images/boys.jpg",
  },
  {
    id: 1,
    title: "Levitating",
    artist: "Dua Lipa",
    genre: "Pop",
    audioSrc: "/audio/levitating.mp3",
    albumCover: "/images/levitating.jpg",
  },
  {
    id: 11,
    title: "Don't Worry Be Happy",
    artist: "Bobby McFerrin",
    genre: "Reggae",
    audioSrc: "/audio/happy.mp3",
    albumCover: "/images/happy.jpg",
  },
  {
    id: 8,
    title: "Mockingbird",
    artist: "Eminem",
    genre: "Hip-Hop",
    audioSrc: "/audio/bird.mp3",
    albumCover: "/images/bird.jpg",
  },
  {
    id: 5,
    title: "Feeling Good",
    artist: "Nina Simone",
    genre: "Jazz",
    audioSrc: "/audio/good.mp3",
    albumCover: "/images/good.jpg",
  },
  {
    id: 3,
    title: "Thunder",
    artist: "Imagine Dragons",
    genre: "Pop",
    audioSrc: "/audio/thunder.mp3",
    albumCover: "/images/thunder.jpg",
  },
  {
    id: 12,
    title: "One Love",
    artist: "Bob Marley and the Wailers",
    genre: "Reggae",
    audioSrc: "/audio/love.mp3",
    albumCover: "/images/love.jpg",
  },
  {
    id: 6,
    title: "Hit the Road Jack",
    artist: "Ray Charles",
    genre: "Jazz",
    audioSrc: "/audio/road.mp3",
    albumCover: "/images/road.jpg",
  },
  {
    id: 2,
    title: "As It Was",
    artist: "Harry Styles",
    genre: "Pop",
    audioSrc: "/audio/as.mp3",
    albumCover: "/images/as.jpg",
  },
  {
    id: 9,
    title: "Mask Off",
    artist: "Future",
    genre: "Hip-Hop",
    audioSrc: "/audio/mask.mp3",
    albumCover: "/images/mask.jpg",
  },
];

function Wave() {
  return (
    <div style={{ display: "flex", gap: 6 }}>
      {[...Array(20)].map((_, i) => (
        <div
          key={i}
          style={{
            width: 6,
            height: 25,
            background: "linear-gradient(180deg, #404852ff, #5db8ff)",
            borderRadius: 3,
            animation: `bounce 1.2s infinite ease-in-out`,
            animationDelay: `${i * 0.15}s`,
          }}
        />
      ))}
      <style>{`
        @keyframes bounce {
          0%, 100% { transform: scaleY(1); }
          50% { transform: scaleY(1.7); }
        }
      `}</style>
    </div>
  );
}

export default function App() {
  const [started, setStarted] = useState(false);
  const [index, setIndex] = useState(0);
  const [likes, setLikes] = useState([]);
  const [showRes, setShowRes] = useState(false);
  const [dragStart, setDragStart] = useState(null);
  const [dragX, setDragX] = useState(0);
  const audioRef = useRef(null);

  const song = songs[index];

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.load();
      audioRef.current.play().catch(() => {});
    }
  }, [index]);

  const favGenre = () => {
    if (likes.length === 0) return "No songs liked :(";
    const counts = likes.reduce((acc, g) => {
      acc[g] = (acc[g] || 0) + 1;
      return acc;
    }, {});
    const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
    return sorted[0][0];
  };

  function pointerDown(e) {
    e.preventDefault();
    setDragStart({ x: e.clientX });
  }
  function pointerMove(e) {
    if (!dragStart) return;
    setDragX(e.clientX - dragStart.x);
  }
  function pointerUp() {
    if (!dragStart) return;
    if (dragX > 120) {
      swipe("like");
    } else if (dragX < -120) {
      swipe("dislike");
    } else {
      setDragX(0);
    }
    setDragStart(null);
  }

  function swipe(dir) {
    if (dir === "like") setLikes((p) => [...p, song.genre]);
    setDragX(dir === "like" ? 500 : -500);
    setTimeout(() => {
      setDragX(0);
      if (index + 1 < songs.length) setIndex(index + 1);
      else setShowRes(true);
    }, 350);
  }

  if (!started) {
    return (
      <>
        <style>{`
          @keyframes bounce {
            0%, 100% { transform: scaleY(1); }
            50% { transform: scaleY(1.7); }
          }
          .bar {
            width: 6px;
            height: 20px;
            background: linear-gradient(180deg, #0a74ff, #5db8ff);
            margin: 0 3px;
            border-radius: 3px;
            display: inline-block;
            animation: bounce 1.2s infinite ease-in-out;
          }
          .bar:nth-child(1) { animation-delay: 0s; }
          .bar:nth-child(2) { animation-delay: 0.2s; }
          .bar:nth-child(3) { animation-delay: 0.4s; }
          .bar:nth-child(4) { animation-delay: 0.6s; }
          .bar:nth-child(5) { animation-delay: 0.8s; }
          button:hover {
            background-color: #0a74ff !important;
          }
          button:active {
            transform: scale(0.95) !important;
          }
          body,html,#root {
            margin:0; padding:0; height:100%;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            overflow: hidden;
          }
        `}</style>
        <div style={styles.home}>
        <div style={styles.logoRow}>
          <img
            src="/images/spotify.png"
            alt="Spotify Logo"
            style={styles.logoImg}
          />
          <span style={styles.cross}>×</span>
          <img
            src="/images/Tinder.png"   
            alt="Tinder Logo"
            style={styles.logoImg}
          />
        </div>
          <h1 style={styles.title}>vibes</h1>
          <p style={styles.subtitle}>
            Tinder but for Music! Have you ever wondered what kind of music you really like?<br />
            Swipe right to like, left to skip, and discover the genre you love.<br />
             Wear headphones for best experiance
          </p>
          <div style={styles.bars}>
            {[...Array(5)].map((_, i) => (
              <div key={i} className="bar" />
            ))}
          </div>
          <button
            style={styles.btn}
            onClick={() => setStarted(true)}
            aria-label="Get Started"
          >
            Get Started
          </button>
        </div>
      </>
    );
  }

  if (showRes) {
    return (
      <div style={styles.result}>
        <h2>Your Match genre is:</h2>
        <h1 style={{ color: "#0a74ff" }}>{favGenre()}</h1>
        <button
          style={styles.btn}
          onClick={() => {
            setStarted(false);
            setIndex(0);
            setLikes([]);
            setShowRes(false);
          }}
          aria-label="Restart"
        >
          Restart
        </button>
      </div>
    );
  }

  const rot = dragX * 0.07;
  const opac = 1 - Math.min(Math.abs(dragX) / 300, 1);
  const cardStyle = {
    ...styles.card,
    transform: `translateX(${dragX}px) rotate(${rot}deg)`,
    opacity: opac,
    transition: dragStart ? "none" : "transform 0.3s ease, opacity 0.3s ease",
    zIndex: 2,
    position: "relative",
  };

  return (
    <div style={styles.app}>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100vh",
          width: "100vw",
          backgroundImage: `url(${song.albumCover})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(20px)",
          opacity: 1,
          zIndex: 2,
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          height: "100vh",
          width: "100vw",
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.7) 0%,rgba(62, 65, 69, 0.8) 100%)",
          zIndex: 1,
          pointerEvents: "none",
        }}
      />

      <div
        style={cardStyle}
        onPointerDown={pointerDown}
        onPointerMove={pointerMove}
        onPointerUp={pointerUp}
        onPointerCancel={pointerUp}
        onPointerLeave={pointerUp}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: 30,
            backgroundImage: `url(${song.albumCover})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "brightness(0.8)",
            zIndex: 0,
          }}
        />
        <audio
          style={styles.audio}
          controls
          autoPlay
          src={song.audioSrc}
          ref={audioRef}
        />
      </div>

      <div
        style={{
          ...styles.overlay,
          opacity: dragX > 40 ? Math.min((dragX - 40) / 120, 0.8) : 0,
          color: "#87b3a0ff",
          right: 40,
          top: 60,
          zIndex: 3,
        }}
      >
        ✓
      </div>
      <div
        style={{
          ...styles.overlay,
          opacity: dragX < -40 ? Math.min((-dragX - 40) / 120, 0.5) : 0,
          color: "#d18b8bff",
          left: 40,
          top: 60,
          zIndex: 3,
        }}
      >
        ✗
      </div>

      <div style={styles.soundWave}>
        <Wave />
      </div>
    </div>
  );
}

const styles = {
  home: {

    height: "100vh",
    width: "100vw",
    background: "linear-gradient(135deg, #000000, #0a74ff)",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "0 20px",
    userSelect: "none",
    position: "relative",
    overflow: "hidden",
  },
  title: {
    fontSize: "4vw",
    fontWeight: "700",
    marginBottom: 15,
    textShadow: "0 0 15px rgba(0,0,0,0.3)",
  },
  subtitle: {
    fontSize: "1.5vw",
    maxWidth: 600,
    marginBottom: 50,
    lineHeight: "1.3em",
    userSelect: "none",
  },
  bars: {
    display: "flex",
    marginBottom: 60,
  },
  logoRow: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 20,
  gap: 15,
  userSelect: "none",
},
logoImg: {
  width: 70,
  height: 70,
  objectFit: "contain",
},
cross: {
  fontSize: 32,
  fontWeight: "700",
  color: "#0a74ff",
  userSelect: "none",
},
  btn: {
    fontSize: "3vw",
    padding: "1.2rem 4rem",
    backgroundColor: "#0a74ff",
    color: "#fff",
    border: "none",
    borderRadius: 40,
    cursor: "pointer",
    boxShadow: "0 10px 25px rgba(10,116,255,0.7)",
    transition: "transform 0.15s ease, backgroundColor 0.3s ease",
    userSelect: "none",
  },
  soundWave: {
    position: "fixed",
    bottom: 20,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 3,
    userSelect: "none",
  },
  app: {
    height: "87vh",
    width: "80vw",
    margin: "auto",
    background: "linear-gradient(135deg, #121212 0%, #313a46ff 80%)",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    userSelect: "none",
    position: "relative",
    overflow: "hidden",
  },
  card: {
    borderRadius: 30,
    width: "80vw",
    maxWidth: 400,
    height: "130vh",
    backgroundColor: "#282c34",
    padding: 0,
    boxShadow: "0 0 40px rgba(59, 63, 67, 0.9)",
    textAlign: "center",
    position: "relative",
    touchAction: "none",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    zIndex: 2,
    overflow: "hidden",
  },
  audio: {
    width: "30vw",
    height: "3vh",
    padding: 10,
    borderRadius: "0 0 30px 30px",
    backgroundColor: "rgba(0,0,0,0.5)",
    outline: "none",
    zIndex: 2,
  },
  overlay: {
    position: "fixed",
    fontSize: 120,
    fontWeight: "900",
    userSelect: "none",
    pointerEvents: "none",
    top: 60,
    transition: "opacity 0.25s ease",
    textShadow: "0 0 25px rgba(0,0,0,0.8)",
  },
  result: {
    height: "100vh",
    width: "100vw",
    background: "linear-gradient(135deg, #000000, #0a74ff)",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    textAlign: "center",
    userSelect: "none",
    overflow: "hidden",
  },
};
